/**
 * P0 Lot 4 — libellés livraison ASAP / programmée (snapshot Commande uniquement).
 * Aligné sur backend/utils/livraisonCommandeDisplay.js
 */

const TZ = 'Europe/Paris'

function toFiniteDelay(value) {
  if (value == null || value === '') return null
  const n = Number(value)
  return Number.isFinite(n) ? n : null
}

export function formatLivraisonHeureHm(value) {
  const raw = String(value || '').trim()
  if (!raw) return ''
  return raw.replace(':', 'h')
}

export function formatLivraisonPlageLabel(heureDebut, heureFin) {
  if (!heureDebut || !heureFin) return null
  return `${formatLivraisonHeureHm(heureDebut)} – ${formatLivraisonHeureHm(heureFin)}`
}

export function formatLivraisonDateLongue(value) {
  if (!value) return null
  let date = value instanceof Date ? value : null
  if (!date && typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
    const [year, month, day] = value.trim().split('-').map(Number)
    date = new Date(Date.UTC(year, month - 1, day, 12))
  } else if (!date) {
    date = new Date(value)
  }
  if (Number.isNaN(date.getTime())) return null
  const label = new Intl.DateTimeFormat('fr-FR', {
    timeZone: TZ,
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  }).format(date)
  return label.charAt(0).toUpperCase() + label.slice(1)
}

export function formatAsapEstimationHint(min, max) {
  const a = toFiniteDelay(min)
  const b = toFiniteDelay(max)
  if (a == null || b == null) return null
  return `Environ ${a} à ${b} min`
}

export function resolveLivraisonCommandeDisplay(commande) {
  if (!commande || commande.modeRetrait !== 'livraison') return null

  if (commande.livraisonProgrammee === true) {
    const plageLabel = formatLivraisonPlageLabel(
      commande.livraisonPlageDebut,
      commande.livraisonPlageFin
    )
    const dateLabel = formatLivraisonDateLongue(commande.livraisonDate)
    return {
      kind: 'programmee',
      title: 'Livraison programmée',
      dateLabel,
      plageLabel,
      estimationHint: null,
      badge: 'Livraison programmée',
    }
  }

  return {
    kind: 'asap',
    title: 'Livraison — Dès que possible',
    dateLabel: null,
    plageLabel: null,
    estimationHint: formatAsapEstimationHint(
      commande.livraisonDelaiMin,
      commande.livraisonDelaiMax
    ),
    badge: 'Livraison',
  }
}

export function resolveLivraisonAdminBadgeMeta(commande) {
  const display = resolveLivraisonCommandeDisplay(commande)
  if (!display) return null
  if (display.kind === 'programmee') {
    return {
      label: 'Livraison programmée',
      className: 'bg-amber-100 text-amber-900',
      kind: 'programmee',
      timingLines: [display.dateLabel, display.plageLabel].filter(Boolean),
    }
  }
  return {
    label: 'Livraison',
    className: 'bg-green-100 text-green-800',
    kind: 'asap',
    timingLines: ['Dès que possible', display.estimationHint].filter(Boolean),
  }
}
